const researchPatientData = {
  "names": null,
  "patientNumbers": [{
    "number": "RESEARCH",
    "type": "D",
    "simpleType": "D",
    "incomingSystem": null
  }],
  "hospitalNumber": "RESEARCH",
  "nhsNumber": null,
  "nhsNumberVerifiedStatus": null,
  "nhsVerificationStatusMarker": null,
  "firstName": "RESEARCH",
  "middleNames": null,
  "familyName": "RESEARCH",
  "title": null,
  "dob": "1900-01-01T00:00:00.000+00:00",
  "dod": null,
  "gender": "Male",
  "genderCode": "1",
  "primaryLanguage": null,
  "primaryLanguageCode": null,
  "interpreterRequired": false,
  "addressLines": ["", "", "", ""],
  "postalCode": "",
  "homePhone": null,
  "workPhone": null,
  "mobilePhone": null,
  "emailAddress": null,
  "scanningStatus": null,
  "inPatientInfo": null,
  "clinicAppointmentInfo": null,
  "gp": {
    "href": "/gp/G9406368"
  },
  "surgery": {
    "href": "/surgeries/J81068"
  },
  "addresses": [{
    "typeName": "H",
    "addressLines": ["", "", "", ""],
    "postalCode": "",
    "__id": null,
    "__type": "com.fortrus.unity.api.model.Address",
    "__version": "1.0",
    "__href": "/patients/null"
  }],
  "documents": {
    "href": "/patients/RESEARCH/documents"
  },
  "alerts": null,
  "emails": [],
  "phoneNumbers": [],
  "nextOfKins": [],
  "pif": {
    "href": "/patients/RESEARCH/pif"
  },
  "ews": null,
  "religion": null,
  "ethnicGroup": null,
  "maritalStatus": null,
  "hasAlerts": false,
  "docAlerts": null,
  "safeguard": null,
  "metadata": null,
  "vip": false,
  "estimatedDOB": null,
  "__id": "RESEARCH",
  "__type": "com.fortrus.unity.api.model.Patient",
  "__version": "2.0",
  "__href": "/patients/RESEARCH"
};

export default researchPatientData;